module.exports = __webpack_public_path__ + "assets/img/mecha-info-title-cbc50bf0.png";